import React from 'react';
import {Route, Switch, Redirect} from 'react-router';
import Loadable from 'react-loadable';
import Loading from 'components/base/Loading';

const Books = Loadable({
  loader: () => import('components/books'),
  loading: () => <Loading />,
});

export default (store) => {
  return (
    <Switch>
      <Route exact path="/" render={() => <Redirect to="/books" />} />
      <Route exact path="/books" component={Books} />
      <Route render={() => <div>Miss</div>} />
    </Switch>
  );
};
